module.exports = __webpack_public_path__ + "static/media/auctions.83af77ff.png";